/**
 * contactEnums.js — Source unique des enums métier partagés côté contact/société.
 *
 * ⚠️ Toute liste ici DOIT rester alphabétique (utiliser sortSelectOptions au rendu si besoin).
 * Les codes value sont stables ; les labels peuvent être mis à jour librement.
 */
import { normaliserRole } from '../utils/contactProfile';

// Types de contact (harmonisation IdentitySection + IdentityContactBlock)
// Trié A→Z, "Autre" en dernier au rendu (via sortSelectOptions).
export const TYPE_CONTACT_OPTIONS = [
  { value: 'acquereur', label: 'Acquéreur' },
  { value: 'acquereur_vendeur', label: 'Acquéreur / Vendeur' },
  { value: 'avocat', label: 'Avocat' },
  { value: 'bailleur', label: 'Bailleur' },
  { value: 'banquier', label: 'Banquier' },
  { value: 'expert_comptable', label: 'Expert-comptable' },
  { value: 'locataire', label: 'Locataire' },
  { value: 'notaire', label: 'Notaire' },
  { value: 'proprietaire', label: 'Propriétaire' },
  { value: 'prospect', label: 'Prospect' },
  { value: 'vendeur', label: 'Vendeur' },
  { value: 'autre', label: 'Autre' },
];

/**
 * lot DD — retrouve l'option correspondant à un rôle stocké, quelle que soit sa graphie
 * (code `acquereur` ou libellé « Acquéreur »). Sert à présélectionner la bonne ligne dans les
 * listes déroulantes : avant, un contact « Acquéreur » affichait « — ».
 * ⛔ Lecture seule : la valeur enregistrée ne change que si l'utilisateur choisit une option.
 */
export const optionRole = (valeur) => {
  const cible = normaliserRole(valeur);
  if (!cible) return null;
  return TYPE_CONTACT_OPTIONS.find(
    (o) => normaliserRole(o.value) === cible || normaliserRole(o.label) === cible,
  ) || null;
};

export const libelleRole = (valeur) => optionRole(valeur)?.label || '';

// Origine du contact
export const ORIGINE_CONTACT_OPTIONS = [
  { value: 'annonce', label: 'Annonce' },
  { value: 'partenaire', label: 'Partenaire' },
  { value: 'prospection', label: 'Prospection' },
  { value: 'recommandation', label: 'Recommandation' },
  { value: 'reseaux_sociaux', label: 'Réseaux sociaux' },
  { value: 'salon', label: 'Salon / événement' },
  { value: 'site_web', label: 'Site web' },
  { value: 'autre', label: 'Autre' },
];

// Profession (fiche financière contact)
export const PROFESSION_OPTIONS = [
  { value: 'chef_entreprise', label: "Chef d'entreprise" },
  { value: 'independant', label: 'Indépendant' },
  { value: 'retraite', label: 'Retraité' },
  { value: 'salarie', label: 'Salarié' },
  { value: 'autre', label: 'Autre' },
];

// Forme juridique (unifiée : personne morale)
// Trié A→Z, "Autre" en dernier au rendu.
export const FORME_JURIDIQUE_OPTIONS = [
  { value: 'Association', label: 'Association' },
  { value: 'Auto-entrepreneur', label: 'Auto-entrepreneur' },
  { value: 'EIRL', label: 'EIRL' },
  { value: 'Entreprise individuelle', label: 'Entreprise individuelle' },
  { value: 'EURL', label: 'EURL' },
  { value: 'SA', label: 'SA' },
  { value: 'SARL', label: 'SARL' },
  { value: 'SARLU', label: 'SARLU' },
  { value: 'SAS', label: 'SAS' },
  { value: 'SASU', label: 'SASU' },
  { value: 'SCI', label: 'SCI' },
  { value: 'SNC', label: 'SNC' },
  { value: 'Autre', label: 'Autre' },
];

// Catégorie de document (fichiers attachés au bien)
export const DOCUMENT_CATEGORIE_OPTIONS = [
  { value: 'bail', label: 'Bail' },
  { value: 'bilan_comptable', label: 'Bilan comptable' },
  { value: 'comptable_financier', label: 'Comptable / financier' },
  { value: 'diagnostic', label: 'Diagnostic' },
  { value: 'document_comptabilite', label: 'Document comptabilité' },
  { value: 'dpe', label: 'DPE' },
  { value: 'plan', label: 'Plan' },
  { value: 'autre', label: 'Autre' },
];
